<div class="offline" *ngIf="!networkStatus">
  <div class="text">
    <p class="title">⚠️ Vous semblez déconnecté d'Internet ⚠️</p>
    <p>Merci de vérifier votre connexion avant de reprendre l'utilisation de EVA !</p>
  </div>
</div>

<router-outlet></router-outlet>

<eva-confirm-dialog />

<p-toast
  class="break-word"
  key="pdo"
  [preventOpenDuplicates]="true"
  [baseZIndex]="99999"
  position="bottom-right"
></p-toast>

<p-toast [style]="{ style: '50px' }" position="bottom-right"></p-toast>

<!-- Toast avec annulation (EvaService.showUndo) -->
<p-toast key="undo" position="bottom-right" [baseZIndex]="99999">
  <ng-template let-message pTemplate="message">
    <div class="eva-undo-toast">
      <span class="eva-undo-toast__text">{{ message.summary }}</span>
      <button type="button" class="eva-undo-toast__action" (click)="evaService.runUndo(message)">Annuler</button>
    </div>
  </ng-template>
</p-toast>
